import { useAuth } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="max-w-7xl mx-auto px-6 py-24 text-center text-muted-foreground">Loading...</div>;
  if (!user) {
    const login = location.pathname.startsWith("/admin") ? "/admin/login" : "/login";
    return <Navigate to={login} state={{ from: location.pathname + location.search }} replace />;
  }
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
